import { FieldLayoutDefaultType } from './field-layout-default-type.enum';

export class FieldLayoutDefault {
  fieldLayoutDefaultId: string;
  fieldLayoutId: string;
  accountRoleId: string;
  defaultType: FieldLayoutDefaultType;

  constructor(layoutId: string, roleId: string, type: FieldLayoutDefaultType) {
    this.fieldLayoutId = layoutId;
    this.accountRoleId = roleId;
    this.defaultType = type;
  }
}
